import styled from 'styled-components';

export const TextArea = styled.textarea`
    height: ${props=> props.altura? props.altura:45}px;
    padding: 2px;
    font-size: ${props=> props.tamFuente? props.tamFuente:11}px;
    line-height: 1.5;
    border-radius: 3px;
    display: inline-block;
    width: ${props => props.ancho? props.ancho: 100}%;
    margin-bottom: ${props => props.margen_abajo?props.margen_abajo:0}px;
    margin-top: ${props => props.margen_arriba?props.margen_arriba:0}px;
    color: #555;
    background-color: #fff;
    background-image: none;
    border: 1px solid #ccc;
    text-transform: ${props => props.mayusculas? 'uppercase': 'none'};
`;